<template>
  <div>
    <Header />
    <Sidebar />
    <MainContainer />
    <!-- <Loading /> -->
  </div>
</template>
<script>
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContainer from './components/MainContainer';
import { mapGetters } from 'vuex';
// import Loading from '@/components/Loading.vue'

export default {
  name: 'Layout',
  components: {
    Header,
    Sidebar,
    MainContainer
    // Loading
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser'
    }),
    isLogin () {
      return this.getUser !== null;
    }
  }
};
</script>
